export default __webpack_public_path__ + "media/images/lp/icon2-274493362fd51609f17b5bf588ae890a.png";